import { useTranslation } from 'react-i18next';
import { normalizeWishLinks, parseFormattedLinks } from './formattedLinks';

/** Render wish text as text and validated HTTP(S) links, never as HTML. */
export function WishText({ children }: { children: string }) {
  const { t } = useTranslation();
  // The recipient endpoint escapes angle brackets; keep rendering as React text,
  // while restoring the markers used by our validated link parser.
  const text = children.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
  return (
    <>
      {parseFormattedLinks(normalizeWishLinks(text, t('game.card.wishLinkLabel'))).map(
        (part, index) =>
          part.type === 'text' ? (
            part.value
          ) : (
            <a
              key={index}
              className="link link--inline"
              href={part.url}
              title={part.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {part.label === 'game.card.wishLinkLabel' ? t('game.card.wishLinkLabel') : part.label}
            </a>
          ),
      )}
    </>
  );
}
